import { Typography } from 'antd'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const NotFoundPage = () => {
  const navigate = useNavigate()
  useEffect(() => {
    setTimeout(() => {
        navigate('/')
    }, 2000)
  }, [])

  return (
    <>
      <div>
        <Typography style={{ fontSize: "4rem", color: '#4d4c4c', textAlign: 'center', position: 'relative', top: '100%', letterSpacing: '4px', textTransform:'uppercase' }}>
          404 page not found
        </Typography>
        <span style={{textAlign: 'center', display:'block', fontSize:'1rem'}}>Redirecting to Home</span>
      </div>
    </>
  )
}

export default NotFoundPage
